<template>
  <div class="apps">
    <v-dialog v-model="whatsapp_dialog" max-width="900">
      <div class="dialog-whats-app-container">
        <div
          class="header mb-7 d-flex justify-space-between align-center w-100"
        >
          <div class="icon d-flex align-center ga-2">
            <img src="@/assets/images/logos_whatsapp-icon.svg" alt="" />
            <p>WhatsApp Steps to Log In</p>
          </div>
          <div
            style="cursor: pointer"
            @click="whatsapp_dialog = false"
            class="close"
          >
            <svg
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 1.5L1 13.5M1 1.5L13 13.5"
                stroke="#717680"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div class="body">
          <v-container class="ma-0 pa-0">
            <v-row dense>
              <v-col cols="7" class="pa-0 ma-0">
                <v-timeline
                  truncate-line="start"
                  side="end"
                  style="width: fit-content"
                >
                  <v-timeline-item dot-color="white" size="small">
                    <template v-slot:icon>
                      <span
                        style="
                          background-color: transparent;
                          border-color: #0d0d0d;
                          color: #0d0d0d;
                          font-size: 14px;
                          font-weight: 500;
                          padding: 0;
                        "
                        >1</span
                      >
                    </template>
                    <p
                      style="color: #1a1a1a; font-size: 14px; font-weight: 500"
                      class="d-flex align center ga-1"
                    >
                      <span>Open WhatsApp</span>
                      <img
                        src="@/assets/images/whats_app_.svg"
                        alt="what app icon"
                      />
                      <span>on your phone</span>
                    </p>
                  </v-timeline-item>
                  <v-timeline-item dot-color="white" size="small">
                    <template v-slot:icon>
                      <span
                        style="
                          background-color: transparent;
                          border-color: #0d0d0d;
                          color: #0d0d0d;
                          font-size: 14px;
                          font-weight: 500;
                          padding: 0;
                        "
                        >2</span
                      >
                    </template>
                    <p
                      style="color: #1a1a1a; font-size: 14px; font-weight: 500"
                      class="d-flex align center ga-1"
                    >
                      <span>On android tab menu</span>
                      <img src="@/assets/images/menu_title.svg" alt="" />
                      <span>on iphone tap settings</span>
                      <img src="@/assets/images/setting_title.svg" alt="" />
                    </p>
                  </v-timeline-item>
                  <v-timeline-item dot-color="white" size="small">
                    <template v-slot:icon>
                      <span
                        style="
                          background-color: transparent;
                          border-color: #0d0d0d;
                          color: #0d0d0d;
                          font-size: 14px;
                          font-weight: 500;
                          padding: 0;
                        "
                        >3</span
                      >
                    </template>
                    <p
                      class="d-flex align center ga-1"
                      style="color: #1a1a1a; font-size: 14px; font-weight: 500"
                    >
                      Tap Linked Devices,then Link device
                    </p>
                  </v-timeline-item>
                  <v-timeline-item dot-color="white" size="small">
                    <template v-slot:icon>
                      <span
                        style="
                          background-color: transparent;
                          border-color: #0d0d0d;
                          color: #0d0d0d;
                          font-size: 14px;
                          font-weight: 500;
                          padding: 0;
                        "
                        >4</span
                      >
                    </template>
                    <p
                      class="d-flex align center ga-1"
                      style="color: #1a1a1a; font-size: 14px; font-weight: 500"
                    >
                      Scan the QR code to confirm
                    </p>
                  </v-timeline-item>
                </v-timeline>
              </v-col>
              <v-col cols="5" class="d-flex align-center justify-center">
                <div class="qr-wrapper">
                  <img v-if="qr_code && !qr_error_message" :src="qr_code" alt="QR Code" />
                  <div v-if="qr_error_message" class="error-message" style="text-align: center; padding: 20px;">
                    <p style="color: #cc0000; font-weight: 600; margin-bottom: 10px; font-size: 16px;">⚠️ Error</p>
                    <p style="color: #666; font-size: 14px; margin-bottom: 15px; line-height: 1.5;">{{ qr_error_message }}</p>
                    <div style="display: flex; gap: 10px; justify-content: center; flex-wrap: wrap;">
                      <button 
                        @click="retryGetQrCode()" 
                        style="padding: 8px 16px; background: #237276; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 14px;"
                      >
                        Retry
                      </button>
                      <button 
                        v-if="isBlockingLinkError(qr_error_message)"
                        @click="disconnectAndRetry()" 
                        style="padding: 8px 16px; background: #cc0000; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 14px;"
                      >
                        Disconnect & Retry
                      </button>
                    </div>
                  </div>
                  <p v-if="!qr_code && !qr_error_message">Loading QR Code...</p>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <div class="footer d-flex justify-end">
          <button
            @click="whatsapp_dialog = false"
            class="cancel"
            style="
              background-color: #f2f2f2;
              border-color: transparent;
              color: #4d4d4d;
              font-size: 14px;
              font-weight: 400;
              border-radius: 8px;
              width: 6.2rem;
              padding: 9px 14px;
            "
          >
            Cancel
          </button>
        </div>
      </div>
    </v-dialog>
    <v-expansion-panels v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-title class="apps-title">
          Marketing App
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <div class="apps-content">
            <div
              v-for="app in marketingApplications"
              :key="app.id"
              class="single-marketing-app d-flex flex-column flex-sm-row justify-space-between align-center"
            >
              <div class="name-image d-flex align-center ga-4">
                <img
                  width="40px"
                  height="40px"
                  :src="app.icon"
                  :alt="app.platform"
                />
                <div class="name-desc d-flex flex-column ga-2">
                  <div class="name">{{ app.platform }}</div>
                  <span class="desc" v-html="app.description"></span>
                </div>
              </div>
              <div class="action d-flex align-center ga-3">
                <div
                  v-if="
                    app.status === 'active' &&
                    (app.platform === 'facebook' ||
                      app.platform === 'instagram' ||
                      app.platform === 'youtube' ||
                      app.platform === 'tiktok')
                  "
                  @click="goToInsights(app.platform)"
                  class="insights"
                >
                  <svg
                    width="22"
                    height="21"
                    viewBox="0 0 22 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.1304 5.21825H21.9999V20.5833H19.1304V5.21825Z"
                      fill="#237276"
                    />
                    <path
                      d="M14.3479 10.0199H17.2175V20.5834H14.3479V10.0199Z"
                      fill="#237276"
                    />
                    <path
                      d="M0 10.9802H2.86957V20.5834H0V10.9802Z"
                      fill="#237276"
                    />
                    <path
                      d="M9.56519 11.9405H12.4348V20.5834H9.56519V11.9405Z"
                      fill="#237276"
                    />
                    <path
                      d="M4.78259 8.09927H7.65216V20.5834H4.78259V8.09927Z"
                      fill="#237276"
                    />
                    <path
                      d="M22 1.85715C22 2.23919 21.8488 2.60558 21.5798 2.87572C21.3107 3.14586 20.9457 3.29762 20.5652 3.29762C20.352 3.29644 20.1415 3.24894 19.9483 3.15838L17.0787 6.03933C17.1741 6.23153 17.2216 6.44405 17.2174 6.65874C17.2174 7.04077 17.0662 7.40716 16.7972 7.67731C16.5281 7.94745 16.1631 8.09921 15.7826 8.09921C15.5796 8.10016 15.3787 8.05784 15.1932 7.97507C15.0077 7.8923 14.8418 7.77096 14.7065 7.61905L12.4348 8.52655C12.4374 8.54406 12.4374 8.56186 12.4348 8.57937C12.4348 8.96141 12.2836 9.3278 12.0145 9.59794C11.7455 9.86808 11.3805 10.0198 11 10.0198C10.6195 10.0198 10.2545 9.86808 9.98546 9.59794C9.71638 9.3278 9.56522 8.96141 9.56522 8.57937C9.56431 8.41579 9.59182 8.2533 9.64652 8.09921L6.97304 5.9529C6.74709 6.09749 6.48532 6.17567 6.21739 6.17858C5.84739 6.18014 5.49168 6.03523 5.22739 5.77524L2.86957 6.96604C2.87429 7.02356 2.87429 7.08137 2.86957 7.13889C2.86977 7.471 2.75567 7.79298 2.54657 8.05032C2.33747 8.30766 2.04622 8.48456 1.72213 8.55107C1.39804 8.61759 1.06101 8.56962 0.768094 8.41531C0.47518 8.26099 0.244375 8.0098 0.114749 7.70425C-0.0148771 7.3987 -0.0353601 7.05757 0.0567668 6.73861C0.148894 6.41964 0.347971 6.14243 0.6203 5.9539C0.892628 5.76537 1.22148 5.67711 1.55118 5.70405C1.88089 5.731 2.19119 5.87149 2.42957 6.10175L4.78261 4.91576C4.77788 4.85663 4.77788 4.79722 4.78261 4.7381C4.78261 4.35606 4.93377 3.98967 5.20285 3.71953C5.47192 3.44939 5.83686 3.29762 6.21739 3.29762C6.59792 3.29762 6.96286 3.44939 7.23194 3.71953C7.50101 3.98967 7.65217 4.35606 7.65217 4.7381C7.65358 4.90172 7.62605 5.0643 7.57087 5.21826L10.2396 7.36457C10.4669 7.21912 10.7304 7.14091 11 7.13889C11.203 7.13795 11.4039 7.18026 11.5894 7.26303C11.7749 7.3458 11.9408 7.46715 12.0761 7.61905L14.3478 6.71635C14.3455 6.69722 14.3455 6.67787 14.3478 6.65874C14.3478 6.2767 14.499 5.91031 14.7681 5.64016C15.0371 5.37002 15.4021 5.21826 15.7826 5.21826C15.9964 5.21953 16.2072 5.26875 16.3996 5.36231L19.2691 2.48135C19.1769 2.28635 19.1295 2.07302 19.1304 1.85715C19.1304 1.47511 19.2816 1.10872 19.5507 0.838577C19.8197 0.568436 20.1847 0.416672 20.5652 0.416672C20.9457 0.416672 21.3107 0.568436 21.5798 0.838577C21.8488 1.10872 22 1.47511 22 1.85715Z"
                      fill="#237276"
                    />
                  </svg>
                </div>
                <!-- <div
                  v-if="app.status === 'active'"
                  @click="addApp()"
                  class="add"
                >
                  <svg
                    width="28"
                    height="29"
                    viewBox="0 0 28 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14 2.83333C16.3074 2.83333 18.563 3.51757 20.4816 4.79952C22.4002 6.08147 23.8955 7.90355 24.7785 10.0354C25.6616 12.1672 25.8926 14.5129 25.4424 16.776C24.9923 19.0392 23.8811 21.118 22.2495 22.7496C20.6179 24.3812 18.5391 25.4923 16.276 25.9425C14.0129 26.3927 11.6671 26.1616 9.53531 25.2786C7.40351 24.3956 5.58143 22.9002 4.29948 20.9816C3.01753 19.0631 2.33329 16.8074 2.33329 14.5C2.33329 12.9679 2.63506 11.4508 3.22136 10.0354C3.80766 8.61989 4.66703 7.33377 5.75038 6.25042C6.83373 5.16707 8.11985 4.30771 9.53531 3.7214C10.9508 3.1351 12.4679 2.83333 14 2.83333ZM8.16662 15.6667H12.8333V20.3333C12.8333 20.6427 12.9562 20.9395 13.175 21.1583C13.3938 21.3771 13.6905 21.5 14 21.5C14.3094 21.5 14.6061 21.3771 14.8249 21.1583C15.0437 20.9395 15.1666 20.6427 15.1666 20.3333V15.6667H19.8333C20.1427 15.6667 20.4395 15.5437 20.6582 15.325C20.877 15.1062 21 14.8094 21 14.5C21 14.1906 20.877 13.8938 20.6582 13.675C20.4395 13.4562 20.1427 13.3333 19.8333 13.3333H15.1666V8.66666C15.1666 8.35724 15.0437 8.0605 14.8249 7.8417C14.6061 7.62291 14.3094 7.5 14 7.5C13.6905 7.5 13.3938 7.62291 13.175 7.8417C12.9562 8.0605 12.8333 8.35724 12.8333 8.66666V13.3333H8.16662C7.8572 13.3333 7.56046 13.4562 7.34166 13.675C7.12287 13.8938 6.99996 14.1906 6.99996 14.5C6.99996 14.8094 7.12287 15.1062 7.34166 15.325C7.56046 15.5437 7.8572 15.6667 8.16662 15.6667Z"
                      fill="#237276"
                    />
                  </svg>
                </div> -->
                <div class="status">
                  <button
                    @click="connectApp(app)"
                    title="Connect"
                    v-if="isAppDisconnected(app)"
                    class="connect"
                  >
                    Connect
                  </button>

                  <button
                    @click="openDisappDialog(app)"
                    title="Disable"
                    v-if="isAppConnected(app)"
                    class="disable"
                  >
                    Disable
                  </button>
                </div>
              </div>
            </div>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <template>
    <v-dialog v-model="disable_dialog" max-width="500" persistent>
      <div class="disable-dialog-container">
        <div class="header d-flex justify-space-between align-center w-100">
          <div class="icon">
            <svg
              width="56"
              height="57"
              viewBox="0 0 56 57"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="4"
                y="4.5"
                width="48"
                height="48"
                rx="24"
                fill="#FEE4E2"
              />
              <rect
                x="4"
                y="4.5"
                width="48"
                height="48"
                rx="24"
                stroke="#FEF3F2"
                stroke-width="8"
              />
              <path
                d="M32 22.5V21.7C32 20.5799 32 20.0198 31.782 19.592C31.5903 19.2157 31.2843 18.9097 30.908 18.718C30.4802 18.5 29.9201 18.5 28.8 18.5H27.2C26.0799 18.5 25.5198 18.5 25.092 18.718C24.7157 18.9097 24.4097 19.2157 24.218 19.592C24 20.0198 24 20.5799 24 21.7V22.5M26 28V33M30 28V33M19 22.5H37M35 22.5V33.7C35 35.3802 35 36.2202 34.673 36.862C34.3854 37.4265 33.9265 37.8854 33.362 38.173C32.7202 38.5 31.8802 38.5 30.2 38.5H25.8C24.1198 38.5 23.2798 38.5 22.638 38.173C22.0735 37.8854 21.6146 37.4265 21.327 36.862C21 36.2202 21 35.3802 21 33.7V22.5"
                stroke="#CC0000"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div @click="disable_dialog = false" class="close">
            <svg
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 1.5L1 13.5M1 1.5L13 13.5"
                stroke="#717680"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div class="body">
          <div class="title">Disconnect {{ current_app.platform }}</div>
          <div class="text">
            Are you sure you want to disconnect {{ current_app.platform }} ?
          </div>
        </div>
        <div class="footer d-flex justify-space-around align-center">
          <button @click="disable_dialog = false" class="cancel">Cancel</button>
          <button @click="disableApp(current_app)" class="disable">
            Disable
          </button>
        </div>
      </div>
    </v-dialog>
  </template>
</template>

<script>
import apiClient from "@/core/buildRequest";
import { toast } from "vue3-toastify";
import { useGeneralStore } from "@/store/General";
import config from "@/../config";
import socket from "@/core/socketIo";

export default {
  name: "IntegrationsIndex",
  data() {
    return {
      panel: 0,
      marketingApplications: [],
      disable_dialog: false,
      current_app: {},
      general_store: useGeneralStore(),
      whatsapp_dialog: false,
      qr_code: null,
      qrInterval: null,
      statusInterval: null,
      whatsapp_status_code: false,
      whatsappSocketListener: null,
      qr_error_message: null,
    };
  },
  mounted() {
    this.getIntegration();
    this.checkStatus();
    this.setupSocketListeners();
    // Connect socket if not already connected
    if (!socket.connected) {
      socket.connect();
    }
  },
  methods: {
    /**
     * Coerce API error/message fields to a displayable string.
     * Backend often returns `error` as an object ({ message, ... }).
     */
    formatWhatsAppText(value) {
      if (value == null || value === false) return null;
      if (typeof value === "string") {
        const trimmed = value.trim();
        return trimmed || null;
      }
      if (typeof value === "number" || typeof value === "boolean") {
        return String(value);
      }
      if (typeof value === "object") {
        if (typeof value.message === "string" && value.message.trim()) {
          return value.message.trim();
        }
        if (typeof value.error === "string" && value.error.trim()) {
          return value.error.trim();
        }
        if (typeof value.msg === "string" && value.msg.trim()) {
          return value.msg.trim();
        }
        try {
          const json = JSON.stringify(value);
          if (json && json !== "{}" && json !== "null") return json;
        } catch (_) {
          /* ignore */
        }
        return null;
      }
      return String(value);
    },
    isBlockingLinkError(message) {
      if (!message || typeof message !== "string") return false;
      const normalized = message.toLowerCase();
      return (
        normalized.includes("can't link") ||
        normalized.includes("cannot link") ||
        normalized.includes("can not link")
      );
    },
    isWaitingWhatsAppState(data, message, errorText) {
      if (data?.initializing) return true;
      const text = `${message || ""} ${errorText || ""}`.toLowerCase();
      return (
        text.includes("not connected") ||
        text.includes("qr is ready") ||
        text.includes("not ready") ||
        text.includes("initializing") ||
        text.includes("please wait") ||
        text.includes("will be available soon")
      );
    },
    stopQrPolling() {
      if (this.qrInterval) {
        clearInterval(this.qrInterval);
        this.qrInterval = null;
      }
    },
    getQrCode() {
      apiClient
        .get(`${config.whatsapp_api_url}/whatsapp/qr`)
        .then((response) => {
          console.log("QR Code response:", response.data);

          const data = response.data?.data || response.data || {};
          const qrUrl = data.qr_url;
          const message = this.formatWhatsAppText(data.message);
          const errorText = this.formatWhatsAppText(data.error);

          // Prefer QR whenever the backend provides one — residual `error`
          // objects on success responses must not hide the image.
          if (qrUrl) {
            this.qr_code = `${qrUrl}?t=${new Date().getTime()}`;
            this.qr_error_message = null;
            return;
          }

          if (data.connected === true) {
            this.qr_error_message = null;
            this.whatsapp_status_code = true;
            return;
          }

          if (
            this.isBlockingLinkError(message) ||
            this.isBlockingLinkError(errorText)
          ) {
            this.qr_error_message =
              (this.isBlockingLinkError(message) ? message : errorText) ||
              "Unable to link WhatsApp devices.";
            this.qr_code = null;
            this.stopQrPolling();
            return;
          }

          // Soft / waiting states: keep an existing QR; don't flip to Error.
          if (this.isWaitingWhatsAppState(data, message, errorText)) {
            if (!this.qr_code) {
              this.qr_error_message = null;
            }
            return;
          }

          // Hard failure only when there is no QR to show.
          if (!this.qr_code) {
            this.qr_error_message =
              errorText ||
              message ||
              "No QR code available. Please try disconnecting and reconnecting.";
          }
        })
        .catch((error) => {
          console.error("Failed to load QR Code:", error);

          const responseData = error.response?.data;
          const errorMessage =
            this.formatWhatsAppText(responseData?.message) ||
            this.formatWhatsAppText(responseData?.error) ||
            this.formatWhatsAppText(error.message) ||
            "Failed to load QR Code. Please try again.";

          // Keep showing a previously loaded QR while waiting for scan.
          if (this.qr_code) {
            return;
          }

          this.qr_error_message = errorMessage;
          this.qr_code = null;
          this.stopQrPolling();
        });
    },
    retryGetQrCode() {
      this.qr_error_message = null;
      this.qr_code = null;
      this.getQrCode();
      // Restart the interval
      if (this.qrInterval) clearInterval(this.qrInterval);
      this.qrInterval = setInterval(() => this.getQrCode(), 15000);
    },
    async disconnectAndRetry() {
      try {
        // Disconnect first
        await apiClient.post(`${config.whatsapp_api_url}/whatsapp/disconnect`);
        console.log('WhatsApp disconnected successfully');
        
        // Wait a bit before retrying
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        // Update status
        this.checkStatus();
        
        // Retry getting QR code
        this.retryGetQrCode();
        
        // Show success message
        this.general_store?.showSnackbar("Disconnected successfully. Please try connecting again.", "#237276");
      } catch (error) {
        console.error("Failed to disconnect WhatsApp:", error);
        this.general_store?.showSnackbar("Failed to disconnect. Please try again.", "#cc0000");
      }
    },
    checkStatus() {
      apiClient
        .get(`${config.whatsapp_api_url}/whatsapp/status`)
        .then((response) => {
          console.log("📱 WhatsApp status response:", response.data);

          // Handle different response structures
          const data = response.data?.data || response.data;
          const connected = data?.connected;

          // Convert to boolean
          const isConnected =
            connected === true ||
            connected === "true" ||
            connected === 1 ||
            connected === "1";

          console.log("📱 WhatsApp connected status:", isConnected);
          this.whatsapp_status_code = isConnected;

          // While waiting for the user to scan, status is "not connected".
          // That must not clear an already-shown QR or flip the modal to Error.
          if (this.whatsapp_dialog && isConnected) {
            this.qr_error_message = null;
            this.whatsapp_dialog = false;
            this.general_store?.showSnackbar(
              "WhatsApp connected successfully",
              "#237276"
            );
          }
        })
        .catch((error) => {
          console.error("Failed to load WhatsApp status:", error);
          // On error, default to disconnected (show Connect button).
          // Do not touch qr_code / qr_error_message while the login modal is open.
          if (!this.whatsapp_dialog) {
            this.whatsapp_status_code = false;
          }
        });
    },
    async connectApp(platform) {
      const platformName = platform.platform.toLowerCase();

      if (platformName === "facebook" || platformName === "instagram") {
        // Facebook Marketing / Super Ad need ad-account scopes. Instagram
        // continues to use its dedicated Login configuration.
        const endpoint =
          platformName === "facebook"
            ? "/auth/facebook?scope_groups=pages,ads"
            : "/auth/instagram/facebook";

        try {
          const response = await apiClient.get(endpoint);
          // OAuth endpoints wrap their payload in `data`; read both shapes to
          // remain compatible with integrations that return it directly.
          const responseData = response.data?.data ?? response.data;
          const redirectUrl = responseData?.redirect_url;

          if (!redirectUrl) {
            throw new Error(
              responseData?.msg ||
                response.data?.msg ||
                "Unable to start the connection."
            );
          }

          window.location.assign(redirectUrl);
        } catch (error) {
          const message =
            error.response?.data?.msg ||
            error.message ||
            "Unable to start the connection. Please try again.";
          this.general_store?.showSnackbar(message, "#cc0000");
        }
        return;
      }

      if (platformName === "whatsapp") {
        this.whatsapp_dialog = true;
        this.current_app = platform;
        this.qr_error_message = null; // Reset error message
        this.qr_code = null; // Reset QR code
        this.getQrCode();
        if (this.qrInterval) clearInterval(this.qrInterval); // احتياطي
        this.qrInterval = setInterval(() => this.getQrCode(), 15000);
        // Check status periodically while dialog is open
        if (this.statusInterval) clearInterval(this.statusInterval);
        this.statusInterval = setInterval(() => this.checkStatus(), 3000);
        this.checkStatus();
      } else {
        window.open(platform.url, "_blank");
      }
    },
    setupSocketListeners() {
      // Listen for WhatsApp connection status updates
      socket.on('whatsapp_connected', () => {
        console.log('✅ WhatsApp connected via socket');
        this.whatsapp_status_code = true;
        this.checkStatus(); // Verify with API
      });
      
      socket.on('whatsapp_disconnected', () => {
        console.log('❌ WhatsApp disconnected via socket');
        this.whatsapp_status_code = false;
        this.checkStatus(); // Verify with API
      });
      
      socket.on('whatsapp_status', (data) => {
        console.log('📱 WhatsApp status update via socket:', data);
        if (data && typeof data.connected !== 'undefined') {
          this.whatsapp_status_code = data.connected === true || data.connected === "true" || data.connected === 1;
        }
      });
      
      // Listen for generic connection events (in case backend uses different event names)
      socket.on('connected', (data) => {
        console.log('✅ Connection event via socket:', data);
        if (data && data.type === 'whatsapp') {
          this.whatsapp_status_code = true;
          this.checkStatus();
        }
      });
      
      socket.on('disconnected', (data) => {
        console.log('❌ Disconnection event via socket:', data);
        if (data && data.type === 'whatsapp') {
          this.whatsapp_status_code = false;
          this.checkStatus();
        }
      });
      
      // Listen for any WhatsApp-related events (if onAny is available)
      if (socket.onAny) {
        this.whatsappSocketListener = (eventName, ...args) => {
          if (eventName.toLowerCase().includes('whatsapp')) {
            console.log(`📱 WhatsApp socket event received: ${eventName}`, args);
            // If it's a status update, check status
            if (eventName.toLowerCase().includes('status') || eventName.toLowerCase().includes('connect')) {
              this.checkStatus();
            }
          }
        };
        socket.onAny(this.whatsappSocketListener);
      }
    },
    isAppConnected(app) {
      if (app.platform.toLowerCase() === "whatsapp") {
        return this.whatsapp_status_code === true || this.whatsapp_status_code === "true" || this.whatsapp_status_code === 1;
      }
      return app.status === "active";
    },
    isAppDisconnected(app) {
      if (app.platform.toLowerCase() === "whatsapp") {
        return this.whatsapp_status_code === false || this.whatsapp_status_code === "false" || this.whatsapp_status_code === 0 || this.whatsapp_status_code === "" || this.whatsapp_status_code === null || this.whatsapp_status_code === undefined;
      }
      return app.status === "inactive";
    },
    getIntegration() {
      apiClient
        .get("/integration/all/integrations")
        .then((response) => {
          console.log(response.data.data);
          this.marketingApplications = response.data.data;
          this.marketingApplications.forEach((app) => {
            app.status =
              !localStorage.getItem(app.platform.toLowerCase() + "_token") ||
              localStorage
                .getItem(app.platform.toLowerCase() + "_token")
                .trim() === ""
                ? "inactive"
                : "active";
            app.description = `Connect your <strong>${app.platform}</strong> account to streamline ad management and campaign tracking. Unlock powerful tools to optimize your marketing efforts and drive results!`;
          });
        })
        .catch((error) => {
          if (error.status === 500) {
            toast("Soon", {
              type: "success",
            });
          }
        });
    },
    openDisappDialog(app) {
      this.current_app = app;
      this.disable_dialog = true;
    },
    disableApp(app) {
      if(app.platform.toLowerCase() === "whatsapp") {
        apiClient.post(`${config.whatsapp_api_url}/whatsapp/disconnect`).then((response) => {
            console.log(response.data);
            this.checkStatus();
        }) 
        
      }else{
      apiClient
        .get("/integration/disable-integration", {
          params: {
            platform: app.platform,
          },
        })
        .then((response) => {
          const platform_name = app.platform.toLowerCase();
          localStorage.removeItem(platform_name + "_token");
          if (!localStorage.getItem(platform_name + "_token")) {
            const currentIndex = this.marketingApplications.findIndex(
              (app) => app.id === this.current_app.id
            );
            this.marketingApplications[currentIndex].status = "inactive";
            this.general_store?.showSnackbar("has been disabled", "#237276");
          }
        })
        .catch((error) => {
          if (error.status === 500) {
            toast("Soon", {
              type: "success",
            });
          }
        });
      
      }
      this.disable_dialog = false;
    },
    goToInsights(name) {
      let p = "";
      switch (name) {
        case "facebook":
          p = "FacebookInsights";
          break;
        case "tiktok":
          p = "TikTokInsights";
          break;

        case "instagram":
          p = "InstagramInsights";
          break;

        case "youtube":
          p = "YouTubeInsights";
          break;

        default:
          break;
      }
      this.$router.push({
        name: p,
      });
    },
  },
  beforeUnmount() {
    clearInterval(this.qrInterval); // وقف التحديث عند الخروج من الصفحة
    clearInterval(this.statusInterval); // وقف التحقق من الحالة
    // Remove socket listeners
    socket.off('whatsapp_connected');
    socket.off('whatsapp_disconnected');
    socket.off('whatsapp_status');
    socket.off('connected');
    socket.off('disconnected');
    // Remove onAny listener if it exists
    if (this.whatsappSocketListener && socket.offAny) {
      socket.offAny(this.whatsappSocketListener);
    }
  },
  watch: {
    whatsapp_dialog(val) {
      if (!val) {
        clearInterval(this.qrInterval);
        this.qrInterval = null;
        clearInterval(this.statusInterval);
        this.statusInterval = null;
        this.checkStatus();
      }
    },
    disable_dialog(val) {
      if (!val) {
        this.checkStatus();
      }
    },
  },
};
</script>

<style scoped>
::v-deep(.v-timeline .v-timeline-divider__dot) {
  background: transparent !important;
}
::v-deep(.v-timeline-divider__inner-dot) {
  border: 1px solid #202224;
}
::v-deep(.v-timeline-divider__after) {
  background: #202224;
}
::v-deep(
    .v-timeline--vertical .v-timeline-item:last-child .v-timeline-divider__after
  ) {
  background: white !important;
}
::v-deep(.v-timeline-divider__before) {
  background: #202224;
}
.dialog-whats-app-container {
  width: 100%;
  height: 100%;
  padding: 16px 24px 16px 24px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 20px 24px -4px rgba(10, 13, 18, 0.1);
}
.dialog-whats-app-container .header .icon p {
  font-weight: 700 !important;
  font-size: 20px;
  color: #202224;
}
::v-deep(.v-timeline-divider__dot--size-small) {
  width: 36px !important;
  height: 36px !important;
}
.apps {
  margin-bottom: 35px;
}
.apps .v-expansion-panels {
  padding: 40px 24px 40px 24px;
  gap: 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
}
.apps-title {
  color: rgba(6, 19, 20, 1);
  font-size: 18px;
  font-weight: 700;
  line-height: 21.78px;
}
.apps-content {
  padding: 16px 30px;
}
.apps-content .single-marketing-app:not(:last-child) {
  border-bottom: solid 1px rgba(230, 230, 230, 1);
}
.name-image .name-desc .name {
  font-size: 14px;
  font-weight: 600;
  line-height: 15px;
  color: rgba(0, 0, 0, 1);
}
.name-image .name-desc .desc {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: rgba(83, 100, 113, 1);
  max-width: 70%;
}
.single-marketing-app {
  margin: 21px 0px;
  padding: 18px 0px;
}
.single-marketing-app .action .status button {
  width: 98px;
  height: 32px;
  border-radius: 8px;
}
.single-marketing-app .action .status .connect:hover {
  background: rgb(23, 72, 75);
}
.single-marketing-app .action .status .connect {
  background: rgba(35, 114, 118, 1);
  color: white;
}
.single-marketing-app .action .status .disable:hover {
  background: rgb(199, 199, 199);
}
.single-marketing-app .action .status .disable {
  background: rgba(230, 230, 230, 1);
  color: rgba(102, 102, 102, 1);
}
.action .insights,
.action .add {
  cursor: pointer;
}
.v-application__wrap {
  min-height: unset !important;
}
.disable-dialog-container {
  width: 100%;
  height: 100%;
  padding: 16px 24px 16px 24px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 20px 24px -4px rgba(10, 13, 18, 0.1);
}
.disable-dialog-container .body {
  padding: 15px 0px;
  margin-bottom: 20px;
}
.disable-dialog-container .body .title {
  font-size: 20px;
  font-weight: 600;
  line-height: 24.2px;
  color: rgba(34, 34, 34, 1);
  margin-bottom: 10px;
}
.disable-dialog-container .header .close {
  cursor: pointer;
}
.disable-dialog-container .body .text {
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
  color: rgba(106, 106, 106, 1);
}
.disable-dialog-container .footer .cancel:hover {
  background: rgb(212, 212, 212);
}
.disable-dialog-container .footer .cancel {
  width: 170px;
  height: 44px;
  padding: 10px 18px 10px 18px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(213, 215, 218, 1);
  color: rgba(65, 70, 81, 1);
}
.disable-dialog-container .footer .disable:hover {
  background: rgb(161, 2, 2);
}
.disable-dialog-container .footer .disable {
  width: 170px;
  height: 44px;
  padding: 10px 18px 10px 18px;
  border-radius: 8px;
  background: rgba(204, 0, 0, 1);
  border: 1px solid rgba(204, 0, 0, 1);
  color: white;
}
</style>
